import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template imports
import Col from  '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from  '@nmx/template/dist/componentLibrary/foundations/Grid/Row';

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      column-count: ${mediumUp ? 2 : 0 };
      margin: 0 ${rem(16)};
      padding-bottom: ${rem(16)};
      text-align: left;
    `;
  }
}`;

export const ColStyledCtaContainer = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding: ${mediumUp ? rem(40) : rem(32)} 0 ${rem(24)};
    `;
  }
}`;

export const RowStyled = styled(Row)`
  background-color: white;
`;